import React, { useEffect, useState } from "react";
import SidebarNavItem from "./SidebarNavItem";
import { Store } from "../../../flux";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";

function SidebarNavItems() {
  const [navItems, setNavItems] = useState(Store.getSidebarItems());
  const onChange = () => {
    setNavItems(Store.getSidebarItems());
    console.log("nav items value : ", navItems);
  };

  useEffect(() => {
    Store.addChangeListener(onChange);
  }, []);

  useEffect(() => {
    Store.removeChangeListener(onChange);
  }, []);

  const changePasswordItem = navItems.find(
    (i) => i.to === "/staff/changePassword"
  );
  const mainItems = navItems.filter((i) => i.to !== "/staff/changePassword");

  
window.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('dynamic-scroll-box');
  
  if (container) {
    // 1. Get the exact height of the div at load time (in pixels)
    const loadHeight = container.getBoundingClientRect().height;
    
    // 2. Lock that height onto the element
    container.style.height = `${loadHeight}px`;
    
    // 3. Enable scrolling now that the height is locked
    container.style.overflowY = 'auto';
  }
});

  return (
    <div 
      id="dynamic-scroll-box" 
      className="nav-wrapper scroll-container"
      style={{ display: "flex", flexDirection: "column", height: "92%" }}
    >
      {/* <Nav className="nav--no-borders flex-column">
        {navItems.map(
          (item, idx) => (
            console.log("nav items value item : ", item),
            (<SidebarNavItem key={idx} item={item} />)
          )
        )}
      </Nav> */}
      {/* <List className="nav--no-borders flex-column">
        {navItems.map((item, idx) =>
          item && item.title ? (
            <ListItem key={idx}>
              <ListItemIcon></ListItemIcon>
              <SidebarNavItem item={item} />
            </ListItem>
          ) : null
        )}
      </List> */}

      {/* Scrollable items */}
      <List className="nav--no-borders" style={{ flex: 1}}>
        {mainItems.map((item, idx) =>
          item && item.title ? (
            <ListItem key={idx}>
              <ListItemIcon></ListItemIcon>
              <SidebarNavItem item={item} />
            </ListItem>
          ) : null
        )}
      </List>

      {/* Fixed bottom item */}
      {changePasswordItem && (
        <div style={{ borderTop: "1px solid #ddd" }}>
          <List className="nav--no-borders">
            <ListItem>
              <ListItemIcon></ListItemIcon>
              <SidebarNavItem item={changePasswordItem} />
            </ListItem>
          </List>
        </div>
      )}
    </div>
  );
}

export default SidebarNavItems;
